export default {
    label_task:{
        en:"Categories",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Category",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Category",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Category",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_code:{
        en:"Code",
        bn:"প্রিফিক্স"
    },
}